import {Component, OnInit, AfterViewInit} from '@angular/core';
import { ServicesService } from '../services.service';
import {ActivatedRoute, Router} from '@angular/router';
import {HttpErrorResponse} from '@angular/common/http';
import {environment} from '../../environments/environment';
import swal from 'sweetalert2';
import * as $ from 'jquery';
import {forEach} from "@angular/router/src/utils/collection";


@Component({
  selector: 'app-newphotoselection',
  templateUrl: './job-photo-selection.component.html',
  styleUrls: ['./job-photo-selection.component.css']
})
export class JobPhotoSelectionComponent implements OnInit, AfterViewInit {
  apiBaseUrl: string = environment.apiBaseUrl;
  header = 'l-header';
  navbar = 'l-navbar l-navbar_t-light l-navbar_expand js-navbar-sticky';
  productid;
  jobid;
  maxIndlength;
  maxGrplength;
  photoid;
  groupImage = [];
  indImage = [];
  removeStyle = [];
  removeStyle2 = [];
  removeStyle3 = [];
  removeStyle4 = [];
  clientName;
  shootName;  
  clientType;
  clientId;
  safeHtmlContent=[];
  safeHtmlContentInd=[];
  individual_photos_availability = 0;
  group_photos_availability = 0;

  group_photos_quantity= [];
  individual_photos_quantity = [];
  group_photos_quant= [];
  individual_photos_quant = [];
  // individualimageselected=[];
  no_product_flag = 0;

  // -----
  individualAndGruopPhotoes = [];
  loadData=0;
  modelImagesArrayGp        = [];
  modelImagesArrayInd        = [];
  modelImagesArrayChunksGp  = [];
  modelImagesArrayChunksInd  = [];

  groupOrIndividualButtonClicked;

  setIndividualOrGroupIndex;

  hrefModel = '';

  addtocartdisabled = false;
  // -----Private
  uniqueCode=[];
  privateImagePopUp = 'assets/img/dummy.jpg';
  clearIntervalInstance;
  imageFound = [];
  studentDet = [];
    dummyImg;
    marginTop = '0%';
    requiedProductData = [];
    additionalProductData = [];
    freeShipmentTimeLeftr;
    freeShipmentTimeLefta;
    freeShipmentTimeLeftFlag;
    productExpire = true;
    image_id;
  /*pName = '';
  sName = '';
  cName = '';
  erMsg= '';*/
  individualPhotosQuantity='';

  jobPhotos;

  constructor(private route: ActivatedRoute, private _service: ServicesService, private router: Router) {
    /*this.route.queryParams.subscribe(params => {
      this.jobid = params['jobid'];
      alert(this.jobid);
      
    });*/
    this.route.params.subscribe( params => {
      this.jobid = params['jobid'];
      // alert(this.jobid);
    });

  }

  ngOnInit() {
    // console.log(this.jobid);
    this.getJob();
    // this.getPrivateImage();
  }

  getJob() {    
      this._service.getNewJob(this.jobid).subscribe((data: any) => {
        const client_id =  (data.result.timeleft[0]) ? data.result.timeleft[0].client_id : '';
        $('.tb-preloader-wave').fadeOut();
        $('#tb-preloader').delay(200).fadeOut('slow').remove();

        this.jobPhotos = data.result;
        this.image_id = data.result.timeleft[0].id;
        this.clientName = data.result.timeleft[0].client_name;
        this.shootName = data.result.timeleft[0].shoot_name;
        this.freeShipmentTimeLeftFlag = data.result.timeleft[0].freeShipmentTimeLeftFlag;
        this.freeShipmentTimeLefta  = data.result.timeleft[0].freeShipmentTimeLeft;
        console.log(this.jobPhotos);
 
      },    (err: HttpErrorResponse) => { });

  }

  ngAfterViewInit(){}

  public chunks(array, size) {
    let results = [];
    results = [];
    while (array.length) {
      results.push(array.splice(0, size));
    }
    return results;
  }

  public moveBack() {
    swal({
      title: 'Oops!',
      html: "Going back to the products will not add this product to your cart if you have not selected your photos.<br> To add the product to your cart once your photo selections are made please click on the Add to Cart button below. <i class='fa fa-frown-o'></i>",
      type: 'warning',
      confirmButtonText: 'Ok',
      showCancelButton: true,
      focusCancel: true,
      cancelButtonColor: '#d33',
    }).then((willDelete) => {
      if (willDelete.value) {
        this.router.navigate(['/product', this.jobid]);
        // this.router.navigate(['product'], { queryParams: {'jobid': this.jobid}});
      }
    });
    // console.log('moveBack');
  }
  getPhotos() {
    this._service.getPhotos(this.jobid).subscribe((data: any) => {
      // console.log('data', data);
      this.individualAndGruopPhotoes = data.result;
      // console.log('individualAndGruopPhotoes ',this.individualAndGruopPhotoes);
      this.getModelFlag(0,1);
    });
  }
  // This function will decide model + previous seleted image + set image in the model
  getModelFlag(index, groupOrIndividual) {
    // alert(index);
    // alert(groupOrIndividual);
    // this.erMsg = '';
    // this.pName=''; this.sName='';this.cName='';
    this.setIndividualOrGroupIndex = index;
    // console.log('setIndividualOrGroupIndex', this.individualAndGruopPhotoes);

    // Private mode reset code
    this.privateImagePopUp = 'assets/img/dummy.jpg';
    // this.uniqueCode = [];

    this.modelImagesArrayGp = [];
    this.modelImagesArrayInd = [];
    this.modelImagesArrayChunksGp = [];
    this.modelImagesArrayChunksInd = [];
    /*for (const key in this.individualAndGruopPhotoes[0]) {
      console.log(this.individualAndGruopPhotoes[0][key]);
      alert("test");
    }*/
    // alert(this.individualAndGruopPhotoes.hasOwnProperty(groupOrIndividual));
    // if (this.individualAndGruopPhotoes.hasOwnProperty(groupOrIndividual)) { // this means it is public
      // alert("public");
      // console.log('yash',this.individualAndGruopPhotoes[groupOrIndividual]);
    // groupOrIndividual = 0;
    for (const gori in [0,1]) {
      for (const key in this.individualAndGruopPhotoes[gori]) {
        // console.log('yash',key);
        // console.log('yash',this.individualAndGruopPhotoes[groupOrIndividual][key].photo);
        const photo = this.individualAndGruopPhotoes[gori][key].photo;
        const id = this.individualAndGruopPhotoes[gori][key].id;
        const file_name = this.individualAndGruopPhotoes[gori][key].file_name;
        // console.log(this.individualAndGruopPhotoes[gori][key].is_group);
        let selectedImage = false;
        if (this.individualAndGruopPhotoes[gori][key].is_group==0) { // if this is 1 that means it is individual button is clicked and if 0 means group
          this.modelImagesArrayInd.push({'photo': photo, 'id': id, 'selectedImage': selectedImage,'file_name':file_name});
        }else if(this.individualAndGruopPhotoes[gori][key].is_group==1) {
          this.modelImagesArrayGp.push({'photo': photo, 'id': id, 'selectedImage': selectedImage,'file_name':file_name});
        }
      }
    }

      // console.log("console.log(this.modelImagesArray)",this.modelImagesArray);
      this.modelImagesArrayChunksGp = this.chunks(this.modelImagesArrayGp,1000000);
      this.modelImagesArrayChunksInd = this.chunks(this.modelImagesArrayInd,1000000);
    //   console.log('this.modelImagesArrayChunksGp', this.modelImagesArrayChunksGp);
    // console.log('modelImagesArrayChunksGp '+this.modelImagesArrayChunksGp.length);
    // console.log('modelImagesArrayChunksInd '+this.modelImagesArrayChunksInd.length);
    //   console.log('this.modelImagesArrayChunksInd', this.modelImagesArrayChunksInd);

      // console.log('this.modelImagesArray',this.modelImagesArray);
      //    console.log('groupOrIndividual',groupOrIndividual);
      // alert("here");
      // this.hrefModel =  'Public';
    // }
    /*else {
      // alert("private");
      this.hrefModel =  'Private';
      if (groupOrIndividual) { // if this is 1 that means it is individual button is clicked and if 0 means group
        this.groupOrIndividualButtonClicked = 'individual_photos_quantity';
      }else {
        this.groupOrIndividualButtonClicked = 'group_photos_quantity';
      }
      // console.log('this.groupOrIndividualButtonClicked', this.groupOrIndividualButtonClicked);
    }*/
  }

  getProduct() {
    this._service.getProduct(this.productid).subscribe((data: any) => {
      // console.log('product_data', data);
      if (data.result.length > 0)
      {
        this.no_product_flag = 1;
        this.individual_photos_availability = data.result[0].individual_photos_availability;
        this.clientName                     = data.result[0].name;
        this.group_photos_availability      = data.result[0].group_photos_availability;
        this.group_photos_quantity          = Array(data.result[0].group_photos_quantity);
        this.safeHtmlContent                = Array(data.result[0].group_photos_quantity);
        this.safeHtmlContentInd             = Array(data.result[0].individual_photos_quantity);
        this.individual_photos_quantity     = Array(data.result[0].individual_photos_quantity);
        this.maxIndlength = this.individual_photos_quantity.length;
        this.maxGrplength = this.safeHtmlContent.length;
        // console.log('group_photos_quantity', this.group_photos_quantity.length);
      }else {
        this.no_product_flag = 0;
      }

      $('.tb-preloader-wave').fadeOut();
      $('#tb-preloader').delay(200).fadeOut('slow').remove();

    }, (err: HttpErrorResponse) => {
      this.no_product_flag = 0;
    });
  }
  imageClick(imgSrc, itemId,fileName,id=null,type='',rmsl) {
    // alert(this.maxIndlength);
    // this[this.groupOrIndividualButtonClicked][this.setIndividualOrGroupIndex] = {id: itemId, src: imgSrc ,fileName:fileName};
    this.groupOrIndividualButtonClicked = type;
      let length =this.maxIndlength;
      if(type=='individual_photos_quant'){
          length =this.maxIndlength;
      }else if(type=='group_photos_quant'){
          length =this.maxGrplength;
      }
    if(this[this.groupOrIndividualButtonClicked].length<length) {
      var index = this[this.groupOrIndividualButtonClicked].indexOf(itemId)
      if (index > -1) {
        this[rmsl][id] = 1;
        // alert(this.removeStyle[id]);
        this[this.groupOrIndividualButtonClicked].splice(index, 1);
      } else {
        this[rmsl][id] = 0;
        this[this.groupOrIndividualButtonClicked].push(itemId)
      }
    }else{
      // if (this.groupOrIndividualButtonClicked=='group_photos_quant')
      //   $('#imgSet'+id).attr("src",'');
      var index = this[this.groupOrIndividualButtonClicked].indexOf(itemId)
      if (index > -1) {
        this[rmsl][id] = 1;
        this[this.groupOrIndividualButtonClicked].splice(index, 1);
      }else{
        this[rmsl][id] = 1;
        swal({
          title: 'Oops!',
          text: "You should only select "+length+ " images",
          type: 'warning',
          confirmButtonText: 'Ok',
        });
      }
      // $('.individualimagesel_'+id).css({"background-color": "transparent"})
      /*swal({
        title: 'Oops!',
        text: "you can upload only "+this.maxIndlength+ " images for this product",
        type: 'warning',
        confirmButtonText: 'Ok',
      });*/
    }
   // console.log(this.groupOrIndividualButtonClicked,this[this.groupOrIndividualButtonClicked]);
    /*this.groupOrIndividualButtonClicked = type;
    if(size>1){
      alert("You can select only "+this[this.groupOrIndividualButtonClicked].length+"images for this product"+this.groupOrIndividualButtonClicked);
    }else{
      if (!this[this.groupOrIndividualButtonClicked][id]) {
        alert("here");
        this[this.groupOrIndividualButtonClicked][id] = {id: itemId, src: imgSrc, fileName: fileName};
        console.log(this.groupOrIndividualButtonClicked, this[this.groupOrIndividualButtonClicked]);
      }else if(this[this.groupOrIndividualButtonClicked][id]){
        this[this.groupOrIndividualButtonClicked].splice(id, 1);
        console.log(this.groupOrIndividualButtonClicked, this[this.groupOrIndividualButtonClicked]);
        // this[this.groupOrIndividualButtonClicked][id] = {};
      }
    }*/
      // console.log(this.groupOrIndividualButtonClicked, this[this.groupOrIndividualButtonClicked]);
  }
  groupImageClick(imgSrc, itemId,fileName,id=null,type='') {
    this.groupOrIndividualButtonClicked = type;
    // alert(this.groupOrIndividualButtonClicked);
    // console.log('this[this.groupOrIndividualButtonClicked].length',this[this.groupOrIndividualButtonClicked].length);
    let length =this.maxIndlength;
    if(type=='individual_photos_quant'){
      length =this.maxIndlength;
    }else if(type=='group_photos_quant'){
      length =this.maxGrplength;
    }
    if (this[this.groupOrIndividualButtonClicked].length < length) {
      var index = this[this.groupOrIndividualButtonClicked].indexOf(itemId)
      if (index > -1) {
        // this.removeStyle2[id] = 1;
        this[this.groupOrIndividualButtonClicked].splice(index, 1);
      } else {
        // this.removeStyle2[id] = 0;
        this[this.groupOrIndividualButtonClicked].push(itemId);

      }
    } else {
      // if (this.groupOrIndividualButtonClicked=='group_photos_quant')
      //   $('#imgSet'+id).attr("src",'');
      var index = this[this.groupOrIndividualButtonClicked].indexOf(itemId)
      if (index > -1) {
        // this.removeStyle2[id] = 1;
        this[this.groupOrIndividualButtonClicked].splice(index, 1);
      } else {
        // this.removeStyle2[id] = 1;
        swal({
          title: 'Oops!',
          text: "You should only select" + length + " images",
          type: 'warning',
          confirmButtonText: 'Ok',
        });
      }
    }
  //  console.log(this.groupOrIndividualButtonClicked,this[this.groupOrIndividualButtonClicked])
  }

  getImage(i, arrayType, type) { // arrayType = individual_photos_quantity || group_photos_quantity
   // console.log(this[arrayType]);
    if(type == 'group') {
      if (!this[arrayType][0][i]) {
        return 'assets/img/dummy.jpg';
      }
      return this.apiBaseUrl + '/' + this[arrayType][0][i].photo;
    }

    if(type == 'individual') {
      if (!this[arrayType][1][i]) {
        return 'assets/img/dummy.jpg';
      }
      return this.apiBaseUrl + '/' + this[arrayType][1][i].photo;
    }
  }

  getFileName(i, arrayType) { // arrayType = individual_photos_quantity || group_photos_quantity
    if (!this[arrayType][i]) {
      return '';
    }
    return this[arrayType][i].fileName;
  }
  resetImage(id,itemId,rmsl,imgId,imgType,goi){
    // alert(goi);
    this[rmsl][id] = 1;
    /*alert(itemId);
    alert(rmsl);
    alert(imgId);
    alert(imgType);*/
    $(imgId+id).attr("src",'assets/img/dummy.jpg');
    var index  = this[goi].indexOf(itemId)
    // var indexGp=this.groupImage.indexOf(itemId)
    // alert(index);
    if (index > -1) {
      // alert(index);
      this[goi].splice(index, 1);
    }
    /*if (indexGp > -1) {
      alert(indexGp);*/
      this[imgType][id]['link']=null;
      this[imgType][id]['id']=null;
      this[imgType][id]['name']=null;
    // }
    // console.log('this[imgType]',imgType,this[imgType]);
    // console.log('group_type',goi,this[goi]);
    // this.privateImagePopUp = '';
    // alert("ff");
  }

  //Rishabh's Code
  chekPvtImageName(imgType,id) {
    if(this[imgType][id] != undefined) {
      return this[imgType][id]['name'];
    }
  }
  getPrivateImage(type=null,imgType, imgHtml, imgId, rmsel) {
    // alert(type);
    // alert(imgType);
    // alert(imgHtml);
    // alert(imgId);
    const file_name = this.uniqueCode[type];
    const job_id = this.jobid;
    const data = {'file_name': file_name, 'job_id': job_id};
    //  console.log('getPrivateImage data', data);

    this._service.getPrivateImage(data).subscribe((res: any) => {
      console.log("res==",res);
      // return;
      // console.log('getPrivateImage service res', res);
      let flag = 0;
      if (res.status == 200) {
        this.router.navigate(['/jobpphotosproducts'], { queryParams: { image_id : res.result.id, job_id:job_id, file_name: file_name, is_individual: res.result.is_individual} });
      }
      if (res.status == 204) {
        swal({
          title: 'Oops! Image not found',
          text: 'Please enter correct image code',
          type: 'warning',
          confirmButtonText: 'Ok',
        });
      }

    });


  }

  showImage(src) {
    const imgUrl =  src;
    // console.log(imgUrl);
    swal({
      html:  "<img src='" + imgUrl + "' style='width:100%;'>",
      showConfirmButton: false,
      showCancelButton:true,
      cancelButtonText: "Close",
      cancelButtonColor: '#d33',
      //width:'600px',
      //height:'600px',
      customClass: 'swal-wide',
    });
  }

  /*verifyFormData() {
    // console.log('groupOrIndividualButtonClicked= ',this.groupOrIndividualButtonClicked);
    // console.log('setIndividualOrGroupIndex= ',this.setIndividualOrGroupIndex);
    if(this.pName=='' || this.sName=='' || this.cName==''){
      this.erMsg='Please fill all the above fields';
    }else if(this[this.groupOrIndividualButtonClicked][this.setIndividualOrGroupIndex]==undefined){
      this.erMsg='Please Select an image';
    }else{
      this[this.groupOrIndividualButtonClicked][this.setIndividualOrGroupIndex].imageDetail = { 'cname':this.cName,pname:this.pName, sname: this.sName};
      // $('#myModal').modal('hide');
      $('.close-modal').trigger('click');
      this.pName=''; this.sName='';this.cName='';
    }
    // this[this.groupOrIndividualButtonClicked].imageDetail = { 'cname':this.pName,pname:this.cName, sname: this.sName};
    // console.log(this[this.groupOrIndividualButtonClicked]);
  }*/

  addToCart() {
    // const length = this.individual_photos_quantity;
    // console.log('addToCart', this.individual_photos_quantity[0]);
    let allPhotoesSelectedFlag = true;
    // console.log(this.group_photos_quant.length);
    // console.log(this.individual_photos_quant.length);
    if(this.group_photos_quant.length!=this.maxGrplength){
      allPhotoesSelectedFlag = false;
    }
    if(this.individual_photos_quant.length!=this.maxIndlength){
      allPhotoesSelectedFlag = false;
    }

    /*if (this.individual_photos_quantity) {
      for (const individual of this.individual_photos_quantity) {
        alert(individual);
        if (individual == undefined) {
          allPhotoesSelectedFlag = false;
        }
      }
    }

    if (this.group_photos_quantity) {
      for (const group of this.group_photos_quant) {
        if (group == undefined) {
          allPhotoesSelectedFlag = false;
        }
      }
    }*/

    if (!allPhotoesSelectedFlag) {
      swal({
        title: 'Oops!',
        text: 'Please select all required photos for this product',
        type: 'warning',
        confirmButtonText: 'Ok',
      });
    }else {
      this.addtocartdisabled = true;
      const userData =  localStorage.getItem('userData') ? JSON.parse(localStorage.getItem('userData')) : {};

      const user_id     = userData.hasOwnProperty('id') ?  userData.id : '';

      if (user_id == '') {
        swal({
          title: 'Oops!',
          text: 'In order to add products to your cart and complete an order, you have to be logged in to a verified account. Please login or Register your account to continue.',
          type: 'warning',
          confirmButtonText: 'Ok',
        });
        return;
      }
      const product_id  = this.productid;
      const job_id      = this.jobid;
      let item_id;
      let item_id_arr   = [];
      item_id_arr   = this.individual_photos_quant.concat(this.group_photos_quant);
   //   console.log('Item ID Arr',item_id_arr);
      let item_det_arr   = {};
      let item_det_pocket   = [];
      // console.log('individual_photos_quantity',this.individual_photos_quantity);
      /*if (this.individual_photos_quant) {
        // let i=0;
        for (const individual of this.individual_photos_quant) {
          // console.log('loop',individual);
          item_id = individual.id;
          item_id_arr.push(item_id);
          // item_det_pocket.push([item_id,individual.imageDetail]);
          if(this.clientType=='school')
            item_det_arr[item_id] = {'detail':individual.imageDetail};
          // const data = {'user_id': user_id, 'product_id': product_id, 'job_id': job_id, 'item_id': item_id};
          // this._service.addproduct(data).subscribe((data1: any) => {
          //
          // });
        }
      }
      // console.log('group_photos_quantity',this.group_photos_quantity);
      // item_det_arr = [];
      if (this.group_photos_quant) {
        for (const group of this.group_photos_quant) {
          // console.log('loop',group.id);
          item_id = group.id;
          item_id_arr.push(item_id);
          if(this.clientType=='school')
            item_det_arr[item_id] = {'detail':group.imageDetail};
          // const data = {'user_id': user_id, 'product_id': product_id, 'job_id': job_id, 'item_id': item_id};
          // console.log(data);
          // this._service.addproduct(data).subscribe((data1: any) => {
          //
          // });
        }
      }*/

      const data = {'user_id': user_id, 'product_id': product_id, 'job_id': job_id, 'item_id': item_id_arr};
      // console.log('add to cart data', data);
      this._service.addproduct(data).subscribe((data1: any) => {
        // console.log('add to cart response', data1);
        const that = this;
        if (data1) {
          swal({
            title: 'Congratulations!',
            text: 'The product has been added to your cart.',
            type: 'success',
            confirmButtonText: 'Ok',
          }).then(function(isConfirm) {
            //that.router.navigate(['/product'],{ queryParams: { jobid: that.jobid } } );
            that.router.navigate(['/product', that.jobid]);
          });
        }else {
          swal({
            title: 'Opps!',
            text: 'Something went wrong',
            type: 'error',
            confirmButtonText: 'Ok',
          });
        }
      });
    }

  }
}



// WEBPACK FOOTER //
// /var/www/html/oneills-web-qa/src/app/job-photo-selection/job-photo-selection.component.ts